import { useCallback, useEffect } from "react"
import { useToken } from "src/utils/hooks/useToken"
import { SyncOutlined } from "@ant-design/icons"
import { notification } from "antd"
import { Samples } from "./db"
import { defaultHeaders } from "src/constants"
import mergebounce from "mergebounce"
import { effect, signal } from "@maverick-js/signals"
// import { Collection } from "@signaldb/core"
// import createIndexedDBAdapter from '@signaldb/indexeddb'
import oboe from "oboe"
import { useVariableValue } from "@devcycle/devcycle-react-sdk"

const apiBaseUrl = process.env.REACT_APP_API_URL + 'v1/data'
const apiPullPath = "/_samples_stream"

type Sample = {
  id: IDBValidKey
} & Record<string, any>

interface UseSync {
  autoSync?: boolean
}


// const RemoteChanges = new Collection({ persistence: createIndexedDBAdapter("RemoteChanges") })
// const LocalChanges = new Collection({ persistence: createIndexedDBAdapter("LocalChanges") })



const insertSamples = mergebounce(
  (samples: Sample[]) => {
    setTimeout(() => {
      try {
        Samples.insertMany(samples)
      } catch (error) {
        for (const sample of samples)
          Samples.replaceOne({ id: sample.id }, sample, { upsert: true })
      }
    }, 3000)
  },
  10,
  { promise: true, concatArrays: true }
)

const current = signal(0)
const isSyncing = signal(false)
effect(() => { console.log("isSyncing", isSyncing()) })

export const useSync = ({ autoSync }: UseSync = { autoSync: false }) => {
  const dim_rd = useVariableValue("dimensionality-reduction", false);
  const token = useToken()
  const [api, contextHolder] = notification.useNotification({ placement: "bottomRight" });

  const pullSamples = useCallback(async () => {
    if (!isSyncing() && dim_rd) {

      isSyncing.set(true)
      const since = localStorage.getItem('since')
      const query = since ? `?since=${since}` : ``
      const url = `${apiBaseUrl}${apiPullPath}${query}`
      let index = 0
      let count = 0
      await oboe({
        url,
        headers: {
          ...defaultHeaders,
          token
        }
      })
        .node("{count}", ({ count: _count }) => {
          // console.log("🚀 ~ .node ~ _count:", _count)
          count = _count
        })
        .node("{id name}", async sample => {
          // console.log("🚀 ~ pullSamples ~ sample:", sample)
          index++
          current.set(index)
          await insertSamples([sample])
          api.info({
            key: "sync-progress",
            message: `Syncing...`,
            description: `${current()} samples synced of ${count}.`,
            icon: <SyncOutlined spin />,
            duration: 1,
            closeIcon: null
          })
        })
        .node("{since}", ({ since }) => {
          // console.log("🚀 ~ .node ~ since:", since)
          localStorage.setItem("since", since)
          current.set(0)
          api.success({
            key: "sync-progress",
            message: `Synced`,
            description: `${count} samples synced.`,
            duration: 2,
            closeIcon: null
          })
        })
        .fail((error) => {
          // console.log("🚀 ~ .fail ~ error:", error)
          current.set(0)
          api.error({
            key: "sync-progress",
            message: `Synced failure`,
            description: `Samples not synced.`,
            duration: 2,
            closeIcon: null
          })
        })
      isSyncing.set(false)
    }
  }, [api, dim_rd, token])

  useEffect(() => {
    dim_rd && !isSyncing() && autoSync && token && pullSamples()
  }, [autoSync, dim_rd, pullSamples, token])

  return { pullSamples, progressBar: contextHolder }
}